import { FC } from "react";
import { Spinner } from "@fluentui/react";
const Loader: FC = () => {
  return <Spinner />;
};

export default Loader;
